import {css} from 'lit';

export default css`

.header {
  background-color: #fff;
  box-shadow: 0 1px 1px rgba(2, 40, 81, 0.15);
}
.header__bar {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  min-height: 2rem;
  background-color: #d8d8d8;
}
@media (max-width: 991px) {
  .header__bar {
    display: none;
  }
}
.header__university {
  display: flex;
  align-items: center;
  height: 2rem;
  padding-right: 0.75rem;
  background-color: #e5e5e5;
}
.header__university:before {
  width: 0.75rem;
  height: 2rem;
  margin-right: 0.75rem;
  margin-left: -0.75rem;
  background-color: #e5e5e5;
  clip-path: polygon(93% 0, 110% 0, 110% 102%, 0% 102%);
  content: "";
}
.header__university a {
  display: flex;
  margin-left: 0.5rem;
}
.header .ucd-logo {
  width: auto;
  height: 1.25rem;
}
@media (min-width: 992px) {
  .header .ucd-logo {
    height: 0.75rem;
  }
}
.header__navbar {
  background-color: #022851;
  box-shadow: 0 2px 1px rgba(2, 40, 81, 0.15);
}
.has-mega .header__navbar {
  background-color: #fff;
}

.site-logo {
  max-height: 6.25rem;
}

`;